import React, { useState,useRef ,useEffect } from "react";
import {
  Layout,
  Menu,
  Avatar,
  Dropdown,
  Typography,
  Button,
  Grid,
  message,
} from "antd";
import {
  HomeOutlined,
  LogoutOutlined,
  TrophyOutlined,
  NotificationOutlined,
  MenuOutlined,QuestionCircleOutlined,MessageOutlined
} from "@ant-design/icons";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { logout } from "../../store/authSlice";
import "./MainLayout.css";
import ImportExportIcon from "../icons/ImportExport";
import ReArrangeListIcon from "../icons/ReArrangeList";
import OrganiseHomeScreenIcon from "../icons/OrganiseHome";

const { Header, Sider, Content } = Layout;
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const MainLayout: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.auth.user);
  const screens = useBreakpoint();

  const [collapsed, setCollapsed] = useState<boolean>(false);
  const isMobile = !screens.md;

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };


  useEffect(() => {
  const TIMEOUT_MINUTES = Number(process.env.REACT_APP_SESSION_TIMEOUT_MINUTES) || 480; // 8 hours default
  const TIMEOUT_MS = TIMEOUT_MINUTES * 60 * 1000;
  let timer: NodeJS.Timeout;

  const resetTimer = () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      message.warning("Your session has expired due to inactivity.");
      localStorage.clear();
      sessionStorage.clear();
      handleLogout();
    }, TIMEOUT_MS);
  };

  // Define the events that reset the timer
  const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"];

  // Use a stable function reference for cleanup
  const handleUserActivity = () => resetTimer();

  // Attach all listeners
  events.forEach((event) => window.addEventListener(event, handleUserActivity));

  // Initialize timer once
  resetTimer();

  return () => {
    if (timer) clearTimeout(timer);
    events.forEach((event) => window.removeEventListener(event, handleUserActivity));
  };
}, []); // ✅ Empty dependency array — runs only once

  const menu = (
    <Menu
      items={[
        {
          key: "logout",
          icon: <LogoutOutlined />,
          label: "Logout",
          onClick: handleLogout,
        },
      ]}
    />
  );

  const userName = user?.fullname || "Admin User";
  const userEmail = user?.email || "admin@example.com";
  const userInitial =
    user?.fullname?.charAt(0).toUpperCase() ||
    user?.email?.charAt(0).toUpperCase() ||
    "?";

  const menuItems = [
    {
      key: "1",
      icon: <HomeOutlined />,
      label: "Home",
      path: "/Home",
    },
    {
      key: "2",
      icon: <TrophyOutlined />,
      label: "Contest Support",
      path: "/contest-dashboard",
    },
    {
      key: "3",
      icon: <ImportExportIcon />,
      label: "Data Import Export",
      path: "/data-imp-exp-home",
    },
    {
      key: "4",
      icon: <OrganiseHomeScreenIcon />,
      label: "Organize Homepage",
      path: "/organizehome",
    },
    {
      key: "5",
      icon: <ReArrangeListIcon />,
      label: "Rearrange Lists",
      path: "/rearrange-lists-home",
    },
    {
      key: "6",
      icon: <NotificationOutlined />,
      label: "Notification Management",
      path: "/Notification-Management-home",
    },
     {
      key: "7",
      icon: <QuestionCircleOutlined />,
      label: "FAQs",
      path: "/faqs-Management-Home",
    },
    {
      key: "8",
      icon: <MessageOutlined />,
      label: "OTP Bypass",
      path: "/MobileOTP",
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Sidebar */}
      <Sider
        theme="light"
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        breakpoint="md"
        collapsedWidth={isMobile ? 0 : 80}
        width={238}
        style={{
          position: isMobile ? "fixed" : "relative",
          zIndex: 1000,
          height: "100vh",
          transition: "all 0.3s ease-in-out",
        }}
      >
        {/* Logo */}
        <div
          style={{
            padding: 10,
            textAlign: "center",
            backgroundColor: "#41787C",
          }}
        >
          <img
            src="/logo-02-w.png"
            alt="Admin Logo"
            style={{
              width: collapsed ? 40 : 120,
              height: 45,
              objectFit: "contain",
              transition: "all 0.3s",
            }}
          />
        </div>

        {/* Menu List */}
        <Menu
          mode="inline"
          style={{ fontWeight: 500 }}
          items={menuItems.map((item) => ({
            key: item.key,
            icon: item.icon,
            label: (
              <span
                style={{
                  fontSize: collapsed ? 0 : 14,
                  opacity: collapsed && isMobile ? 0 : 1,
                  transition: "opacity 0.3s ease",
                }}
              >
                {item.label}
              </span>
            ),
            onClick: () => {
              navigate(item.path || "", { replace: true });
              if (isMobile) setCollapsed(true);
            },
          }))}
        />
      </Sider>

      {/* Main Layout */}
      <Layout>
        <Header
          style={{
            background: "#41787C",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 16px",
            height: 64,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {/* Mobile Menu Toggle */}
            {isMobile && (
              <Button
                type="text"
                icon={<MenuOutlined style={{ color: "white", fontSize: 22 }} />}
                onClick={() => setCollapsed(!collapsed)}
              />
            )}

            <Title
              level={4}
              style={{
                color: "white",
                margin: 0,
                fontSize: 18,
                whiteSpace: "nowrap",
              }}
            >
            </Title>
          </div>

          {/* User Section */}
          <Dropdown overlay={menu} trigger={["click"]}>
            <div
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 10,
                color: "white",
              }}
            >
              <Avatar style={{ backgroundColor: "#2B5C60" }}>{userInitial}</Avatar>
              {!isMobile && (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Text style={{ color: "#fff", fontSize: 14 }}>
                    Hi {userName}
                  </Text>
                  <Text style={{ color: "#d9d9d9", fontSize: 12 }}>
                    {userEmail}
                  </Text>
                </div>
              )}
            </div>
          </Dropdown>
        </Header>

        {/* Page Content */}
        <Content
          style={{
            margin: 16,
            background: "#fff",
            padding: 24,
            borderRadius: 8,
            minHeight: "calc(100vh - 100px)",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
